var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c(_vm.currentComponent,{ref:"com",tag:"component",attrs:{"sid":_vm.vdata.deviceSid,"stringvalue":_vm.vdata.stringValue,"objvalue":_vm.vdata.objectValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }